import { Head, CleanContent } from './ui';
import { capabilities } from '../data';

export default function Capabilities() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="Comprehensive Capabilities" title="More Than a Business Listing"
            text="Turn your static profile into an institutional digital presence where buyers, partners, and institutions can discover, evaluate, and establish commercial trust" />
          <div className="row g-3">
            {capabilities.map(([ic, t, d]) => (
              <div className="col-12 col-sm-6 col-lg-3" key={t}>
                <div className="border border-line rounded-3 p-3 h-100 bg-white shadow-sm">
                  <div className="icon-box rounded-2 d-flex align-items-center justify-content-center mb-3"><i className={`bi ${ic}`} /></div>
                  <div className="h-md mb-1">{t}</div>
                  <p className="p-sm mb-0">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
